import { render } from "./AssignPhysiotherapist.vue?vue&type=template&id=493cd6c2&scoped=true"
import script from "./AssignPhysiotherapist.vue?vue&type=script&lang=js"
export * from "./AssignPhysiotherapist.vue?vue&type=script&lang=js"

import "./AssignPhysiotherapist.vue?vue&type=style&index=0&id=493cd6c2&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-493cd6c2"]])

export default __exports__